var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("transition", { attrs: { name: "fade" } }, [
    _c(
      "article",
      {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.displayItem,
            expression: "displayItem",
          },
        ],
        staticClass: "nti-checkout-line__item",
        attrs: { "data-js": "basket-item", "data-code": "128L1-WW9193-T743_1" },
      },
      [
        _c("section", { staticClass: "nti-checkout-line__item__wrapper" }, [
          _c(
            "div",
            { staticClass: "nti-checkout-line__item__image-container" },
            [
              _c("img", {
                attrs: { src: _vm.lineData.imageUrl, alt: "Image of product" },
              }),
            ]
          ),
          _vm._v(" "),
          _c("div", { staticClass: "nti-checkout-line__item__labels" }, [
            _c("h4", { staticClass: "nti-checkout-line__item__title" }, [
              _c(
                "a",
                {
                  attrs: { href: _vm.lineData.url, title: "Autodesk 3ds Max" },
                },
                [_vm._v(_vm._s(_vm.lineData.displayName))]
              ),
              _vm._v(" "),
              _c("span"),
            ]),
            _vm._v(" "),
            _vm.lineData.disclaimerText
              ? _c(
                  "p",
                  { staticClass: "nti-checkout-line__item__disclaimer" },
                  [_vm._v(_vm._s(_vm.lineData.disclaimerText))]
                )
              : _vm._e(),
            _vm._v(" "),
            _c("p", [_vm._v(_vm._s(_vm.lineData.description))]),
          ]),
        ]),
        _vm._v(" "),
        _c(
          "section",
          { staticClass: "nti-checkout-line__item__info-container" },
          [
            _c(
              "div",
              {
                staticClass:
                  "nti-checkout-line__item__amount nti-checkout-line__item__info-block",
              },
              [
                _c(
                  "label",
                  {
                    staticClass: "nti-checkout-line__item__info-block__label",
                    attrs: { for: "amount-input-field" },
                  },
                  [_vm._v(_vm._s(_vm.verifyLabel("quantityLabel")))]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass:
                      "plus-minus-selector nti-configurator-tablist__plus-minus nti-configurator-tablist__plus-minus--checkout-line",
                  },
                  [
                    _c("button", {
                      staticClass:
                        "plus-minus-selector__btn plus-minus-selector__btn--minus",
                      attrs: { href: "#", "aria-label": "Subtract product" },
                      on: { click: _vm.decrementAmount },
                    }),
                    _vm._v(" "),
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.displayQuantity,
                          expression: "displayQuantity",
                        },
                      ],
                      staticClass:
                        "nti-configurator-tablist__plus-minus__input",
                      attrs: {
                        id: "amount-input-field",
                        name: "product-amount",
                        type: "number",
                      },
                      domProps: { value: _vm.displayQuantity },
                      on: {
                        change: _vm.changeAmount,
                        input: function ($event) {
                          if ($event.target.composing) return
                          _vm.displayQuantity = $event.target.value
                        },
                      },
                    }),
                    _vm._v(" "),
                    _c("button", {
                      staticClass:
                        "plus-minus-selector__btn plus-minus-selector__btn--plus",
                      attrs: { href: "#", "aria-label": "Add product" },
                      on: { click: _vm.incrementAmount },
                    }),
                  ]
                ),
                _vm._v(" "),
                _c(
                  "span",
                  {
                    staticClass:
                      "nti-configurator-tablist__plus-minus__input--mini-cart",
                  },
                  [_vm._v(_vm._s(_vm.displayQuantity))]
                ),
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass:
                  "nti-checkout-line__item__info-block nti-checkout-line__item__info-block--price nti-checkout-line__item__info-block--mini-cart",
              },
              [
                _c(
                  "label",
                  { staticClass: "nti-checkout-line__item__info-block__label" },
                  [_vm._v(_vm._s(_vm.verifyLabel("quantityDescriptorLabel")))]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "nti-checkout-line__item__info-block__price",
                    class: {
                      "nti-checkout-line__item__info-block__price--old":
                        _vm.discountedProduct,
                    },
                  },
                  [
                    _vm._v(
                      "\n                    " +
                        _vm._s(_vm.singleProductPrice) +
                        "\n                "
                    ),
                  ]
                ),
                _vm._v(" "),
                _vm.discountedProduct
                  ? _c(
                      "div",
                      {
                        staticClass:
                          "nti-checkout-line__item__info-block__price nti-checkout-line__item__info-block__price--discount",
                      },
                      [
                        _vm._v(
                          "\n                    " +
                            _vm._s(_vm.singlePriceDiscount) +
                            "\n                "
                        ),
                      ]
                    )
                  : _vm._e(),
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass:
                  "nti-checkout-line__item__info-block nti-checkout-line__item__info-block--price",
                class: {
                  "nti-checkout-line__item__info-block--scroll-margin":
                    _vm.scrollbarMargin,
                },
              },
              [
                _c(
                  "label",
                  {
                    staticClass:
                      "nti-checkout-line__item__info-block__label nti-checkout-line__item__info-block__label--mini-cart",
                  },
                  [_vm._v(_vm._s(_vm.verifyLabel("priceLabel")))]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "nti-checkout-line__item__info-block__price",
                    class: {
                      "nti-checkout-line__item__info-block__price--old":
                        _vm.discountedProduct,
                    },
                  },
                  [
                    _vm._v(
                      "\n                    " +
                        _vm._s(_vm.totalPriceDiscount) +
                        "\n                "
                    ),
                  ]
                ),
                _vm._v(" "),
                _vm.discountedProduct
                  ? _c(
                      "div",
                      {
                        staticClass:
                          "nti-checkout-line__item__info-block__price nti-checkout-line__item__info-block__price--discount",
                      },
                      [
                        _vm._v(
                          "\n                    " +
                            _vm._s(_vm.totalProductPrice) +
                            "\n                "
                        ),
                      ]
                    )
                  : _vm._e(),
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass:
                  "nti-checkout-line__item__remove-container nti-checkout-line__item__info-block",
              },
              [
                _c(
                  "button",
                  {
                    staticClass: "nti-button nti-button--remove-from-cart",
                    attrs: {
                      type: "button",
                      "aria-label": "Remove product",
                      "data-btn": "remove",
                    },
                    on: { click: _vm.removeProduct },
                  },
                  [
                    _c(
                      "div",
                      {
                        staticClass:
                          "nti-svg__container-medium nti-svg--remove-from-cart",
                      },
                      [
                        _c(
                          "svg",
                          {
                            attrs: {
                              xmlns: "http://www.w3.org/2000/svg",
                              viewBox: "0 0 448 512",
                            },
                          },
                          [
                            _c("path", {
                              attrs: {
                                d: "M268 416h24a12 12 0 0 0 12-12V188a12 12 0 0 0-12-12h-24a12 12 0 0 0-12 12v216a12 12 0 0 0 12 12zM432 80h-82.41l-34-56.7A48 48 0 0 0 274.41 0H173.59a48 48 0 0 0-41.16 23.3L98.41 80H16A16 16 0 0 0 0 96v16a16 16 0 0 0 16 16h16v336a48 48 0 0 0 48 48h288a48 48 0 0 0 48-48V128h16a16 16 0 0 0 16-16V96a16 16 0 0 0-16-16zM171.84 50.91A6 6 0 0 1 177 48h94a6 6 0 0 1 5.15 2.91L293.61 80H154.39zM368 464H80V128h288zm-212-48h24a12 12 0 0 0 12-12V188a12 12 0 0 0-12-12h-24a12 12 0 0 0-12 12v216a12 12 0 0 0 12 12z",
                              },
                            }),
                          ]
                        ),
                      ]
                    ),
                    _vm._v(" "),
                    _c("p", [_vm._v(_vm._s(_vm.verifyLabel("removeItem")))]),
                  ]
                ),
              ]
            ),
          ]
        ),
      ]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }